import { get_service_endpoint } from 'ServiceEndpoints';
import { flash } from './CommonActions';
import axios from 'axios';
import { createAction } from 'redux-actions';
import { COUPON_STATUS_REVERSE } from 'components/AccountSettings/DiscountCoupons/base';
const GET_LIVE_COUPON_DATA = createAction('GET_LIVE_COUPON_DATA');
const GET_INACTIVE_COUPON_DATA = createAction('GET_INACTIVE_COUPON_DATA');

const coupons = get_service_endpoint('coupons');
const fabric = get_service_endpoint('fabric');

export const getDiscountCouponData = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${coupons}/`, {
      params: params,
    });
    if (params.filter === COUPON_STATUS_REVERSE.ACTIVE) {
      dispatch(GET_LIVE_COUPON_DATA(res.data.data));
    } else {
      dispatch(GET_INACTIVE_COUPON_DATA(res.data.data));
    }
  } catch (error) {
    dispatch(flash({ message: error.response.data.message }));
  }
};

export const createNewDiscountCoupon = (requestData) => async (dispatch) => {
  try {
    const res = await axios.post(`${coupons}/create`, requestData);
    dispatch(flash({ message: res.data.message }));
    return res.data;
  } catch (error) {
    dispatch(flash({ message: error.response.data.message }));
  }
};
export const deactivateCoupon = (id) => async (dispatch) => {
  try {
    const res = await axios.patch(`${coupons}/deactivate/${id}`);
    dispatch(flash({ message: res.data.message }));
    return res.data;
  } catch (error) {
    dispatch(flash({ message: error.response.data.message }));
  }
};

export const getMediaLink =
  ({ file, percent, setFieldValue, name }) =>
  async (dispatch) => {
    try {
      let token = sessionStorage.getItem('sessionToken');
      if (!token) {
        token = localStorage.getItem('accessToken');
      }
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const res = await axios.post(
        `${fabric}/common/s3/pre-signed-url`,
        {
          fileDetails: [
            {
              fileName: file.name,
              fileType: file.type,
            },
          ],
        },
        {
          headers,
        },
      );

      if (res.status === 200) {
        const mediaUploadFail = () => {
          dispatch(flash({ message: 'Error in uploading file' }));
        };
        await new Promise((resolve, reject) => {
          uploadMedia(res, file, percent, setFieldValue, name, mediaUploadFail);
        });
        dispatch(flash({ message: 'Image uploaded successfully' }));
      }
    } catch (err) {
      console.error('API call or upload failed:', err);
      dispatch(
        flash({
          message: err.message || 'An unexpected error occurred.',
        }),
      );
    }
  };

  export const uploadMedia = async (res, file, percent, setFieldValue, name, onFailure) => {
  const urlData = res?.data?.data;
  const [{ fileName, fileUrl, uploadUrl }] = urlData || [];

  try {
    await axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
        'Skip-Interceptor': true,
      },
      onUploadProgress: ({ loaded, total }) => {
        const percentageUploaded = Math.round((loaded / total) * 100);
        percent(percentageUploaded);
      },
    });

    setFieldValue(name, fileUrl);
  } catch (err) {
    onFailure(err);
  }
};
